import router from '../services/router_service';
import authorController from '../controllers/author_controller';

router.on('route:author', authorController);
